var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.photo)?_c('div',{staticClass:"sn-head-photo"},[_c('img',{style:(_vm.pattern),attrs:{"src":_vm.photo},on:{"load":_vm.handle,"error":_vm.handle}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }